import { atom, atomFamily } from 'recoil';

import { QueryStatus } from 'react-query';

import {
  GiftCouponByCode,
  GiftCouponForPublic,
  GiftCouponForRedemption,
  GiftCouponStatistics,
  RedemptionDashboardData,
} from './giftCoupon.interface';

// 코드로 쿠폰 조회 (public)
export const giftCouponByCodeStatusAtomFamily = atomFamily<QueryStatus, string>({
  key: 'giftCouponByCodeStatusAtomFamily',
  default: 'idle',
});

export const giftCouponByCodeDataAtomFamily = atomFamily<GiftCouponByCode | null, string>(
  {
    key: 'giftCouponByCodeDataAtomFamily',
    default: null,
  },
);

// ID로 쿠폰 조회 (public)
export const giftCouponByIdStatusAtomFamily = atomFamily<QueryStatus, string>({
  key: 'giftCouponByIdStatusAtomFamily',
  default: 'idle',
});

export const giftCouponByIdDataAtomFamily = atomFamily<
  GiftCouponForPublic | null,
  string
>({
  key: 'giftCouponByIdDataAtomFamily',
  default: null,
});

// 교환 신청된 쿠폰 목록 조회 (seller/admin)
export const giftCouponRedemptionListStatusAtom = atom<QueryStatus>({
  key: 'giftCouponRedemptionListStatusAtom',
  default: 'idle',
});

export const giftCouponRedemptionListDataAtom = atom<GiftCouponForRedemption[]>({
  key: 'giftCouponRedemptionListDataAtom',
  default: [],
});

// 발송대기 대시보드 (Admin)
export const redemptionDashboardStatusAtom = atom<QueryStatus>({
  key: 'redemptionDashboardStatusAtom',
  default: 'idle',
});

export const redemptionDashboardDataAtom = atom<RedemptionDashboardData | null>({
  key: 'redemptionDashboardDataAtom',
  default: null,
});

// 쿠폰 통계 (Admin)
export const giftCouponStatisticsStatusAtom = atom<QueryStatus>({
  key: 'giftCouponStatisticsStatusAtom',
  default: 'idle',
});

export const giftCouponStatisticsDataAtom = atom<GiftCouponStatistics | null>({
  key: 'giftCouponStatisticsDataAtom',
  default: null,
});

// 쿠폰 검색 결과 (Admin)
export const giftCouponSearchStatusAtomFamily = atomFamily<QueryStatus, string>({
  key: 'giftCouponSearchStatusAtomFamily',
  default: 'idle',
});

export const giftCouponSearchDataAtomFamily = atomFamily<
  GiftCouponForRedemption[],
  string
>({
  key: 'giftCouponSearchDataAtomFamily',
  default: [],
});
